import { type Module } from 'vuex'
import type { IConfCompxfuncion } from '../interfaces/tablas/IConfCompxfuncion'
import type { IFormComponent } from '@/modules/Administracion/interfaces'

export interface StateFormulario {
  componentesMarcados: string[]
  compFunciones: IConfCompxfuncion[]
  componenteSeleccionadoParaFunciones: IFormComponent | null
}
 const formulario: Module<StateFormulario, unknown> = {
  namespaced: true,  state: (): StateFormulario => {
    return {
      componentesMarcados: [],
      compFunciones: [],
      componenteSeleccionadoParaFunciones: null
    }
  },
  mutations: {
    setFuncionesMarcados(state: StateFormulario, data: { compFunciones: IConfCompxfuncion[] }) {
      state.compFunciones = data.compFunciones
    },
    pushFuncionesMarcados(state: StateFormulario, data: { compFunciones: IConfCompxfuncion }) {
      console.log(data.compFunciones)
      state.compFunciones.unshift(data.compFunciones);
    },
    removeFuncionesMarcados(state: StateFormulario, data: { index: number }) {
      state.compFunciones = state.compFunciones.filter(e=> e != state.compFunciones[data.index])
    },
    pushComponentesMarcados(state: StateFormulario, data: { marcado: string }) {
      state.componentesMarcados.push(data.marcado);    },
    removeComponentesMarcados(state: StateFormulario, data: { marcado: string }) {
      state.componentesMarcados = state.componentesMarcados.filter(e => e !== data.marcado);
    },
    setComponenteSeleccionadoParaFunciones(state: StateFormulario, componente: IFormComponent | null) {
      state.componenteSeleccionadoParaFunciones = componente;
    },
    clearComponenteSeleccionadoParaFunciones(state: StateFormulario) {
      state.componenteSeleccionadoParaFunciones = null;
    }
  },  getters: {
    componentesMarcados: (state: StateFormulario) => {
      return state.componentesMarcados;
    },
    componenteSeleccionadoParaFunciones: (state: StateFormulario) => {
      return state.componenteSeleccionadoParaFunciones;
    }
  },
  actions: {},
}
export default formulario

